export const LEGAL_LINKS = {
  ca: {
    legalNotice: "#",
    conditions: "https://www.ara.cat/condicions_contractacio.html",
    privacy: "https://www.ara.cat/privacitat.html",
    chatbot: "#"
  },
  es: {
    legalNotice: "#",
    conditions: "https://es.ara.cat/condiciones_contratacion.html",
    privacy: "https://es.ara.cat/privacidad.html",
    chatbot: "#"
  },
  en: {
    legalNotice: "#",
    conditions: "https://en.ara.cat/general-conditions/",
    privacy: "https://en.ara.cat/privacy.html",
    chatbot: "#"
  }
} as const;

export type LegalLanguage = keyof typeof LEGAL_LINKS;
